import { useAppSelector } from "../../../../hooks/useRedux";

import IndividualOwnerProfilePage from "./Individual";
import LegalEntityOwnerProfilePage from "./LegalEntity";

export default function ProfilePage() {
  const { ownerInfo } = useAppSelector((state) => state.owner);

  return (
    <>
      {!ownerInfo?.companyName ? (
        <IndividualOwnerProfilePage />
      ) : (
        <LegalEntityOwnerProfilePage />
      )}
    </>
  );
}
